export default "__VITE_ASSET__Nx3_f1fi__"